<div class="relative overflow-x-auto custom-scrollbar">
    <ul class="flex items-center gap-1 min-w-max p-1">
        
        <!-- Active glowing underline -->
        <!-- <span class="absolute bottom-1 h-0.5 bg-primary rounded-full transition-all duration-300 shadow-primary-glow"
              [style.width.px]="activeTabWidth" [style.left.px]="activeTabLeft"></span> -->

        <li *ngFor="let tab of tabs; let i = index" #tabRef>
            <button (click)="onTabClick(tab.id)"
                class="tab-btn relative px-5 py-3 rounded-xl transition-all duration-300 text-[11px] uppercase tracking-wider font-bold whitespace-nowrap"
                [class.text-primary]="isActiveTab(tab.id)" 
                [class.bg-primary-soft]="isActiveTab(tab.id)"
                [class.border]="isActiveTab(tab.id)"
                [class.border-primary-border]="isActiveTab(tab.id)"
                [class.text-text-secondary]="!isActiveTab(tab.id)"
                [class.border]="!isActiveTab(tab.id)"
                [class.border-transparent]="!isActiveTab(tab.id)"
                [class.hover:text-text-primary]="!isActiveTab(tab.id)"
                [class.hover:bg-surface-hover]="!isActiveTab(tab.id)">
                {{ tab.title | translate }}
            </button>
        </li>

    </ul>
</div>